
const keyHex = process.env.REACT_APP_ENCRYPTION_KEY;

const enableEncryption = process.env.REACT_APP_ENABLE_ENCRYPTION === "true";

// Convert hex string → Uint8Array (browser safe)
function hexToBytes(hex) {
  if (!hex || hex.length % 2 !== 0) return new Uint8Array([]);

  const bytes = new Uint8Array(hex.length / 2);

  for (let i = 0; i < hex.length; i += 2) {
    bytes[i / 2] = parseInt(hex.substring(i, i + 2), 16);
  }

  return bytes;
}

const toBase64 = (arr) => btoa(String.fromCharCode(...arr));
const fromBase64 = (str) => Uint8Array.from(atob(str), (c) => c.charCodeAt(0));

const keyBytes = hexToBytes(keyHex);

async function importKey() {
  return crypto.subtle.importKey("raw", keyBytes, { name: "AES-GCM" }, false, [
    "encrypt",
    "decrypt",
  ]);
}

export async function encryptText(text) {
  if (!enableEncryption) return text;

  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encoded = new TextEncoder().encode(text);
  const key = await importKey();

  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    encoded
  );

  return `${toBase64(iv)}:${toBase64(new Uint8Array(encrypted))}`;
}

export async function decryptText(payload) {
  if (!enableEncryption) return payload;

  const [ivB64, dataB64] = payload.split(":");
  const iv = fromBase64(ivB64);
  const data = fromBase64(dataB64);
  const key = await importKey();

  const decrypted = await crypto?.subtle?.decrypt(
    { name: "AES-GCM", iv },
    key,
    data
  );

  return new TextDecoder()?.decode(decrypted);
}